$(window).on("load", function(){

    $(".c-section__title, .c-page-top__title").each(function (id, el) {
        var split = new SplitText(el, {type: "lines, words, chars", linesClass: "t-line", wordsClass: "t-word", charsClass: "t-char"});
        var dl = 0;
        var dc = 0.025;
        var td = 0.2;
        /* $(el).find(".t-char").each(function(id2, el2){
            $(el2).css("--t-delay", `${dl.toFixed(2)}s`);
            $(el2).css("--t-duration", `${td.toFixed(2)}s`);
            dl += dc;
            td += 0.01;
            dc += 0.001;
        }); */
        $(el).find(".t-line").each(function (id2, el2) {
            $(el2).find(".t-char").each(function (id3, el3) {
                $(el3).css("--t-delay", `${dl.toFixed(2)}s`);
                $(el3).css("--t-duration", `${td.toFixed(2)}s`);
                dl += dc;
                td += 0.01;
                dc += 0.001;
            });
            dl -= dc * 3;
        });
    });
    
    /* $(".c-intro-section__title").each(function(id,el){
        var split = new SplitText(el, {type:"words, chars", wordsClass:"t-word", charsClass:"t-char"});
        var dl = 1;
        var dc = 0.025;
        var td = 0.2;
        $(el).find(".t-char").each(function(id2, el2){
            $(el2).css("--t-delay", `${dl.toFixed(2)}s`);
            $(el2).css("--t-duration", `${td.toFixed(2)}s`);
            dl += dc;
            td += 0.01;
            dc += 0.001;
        });
    }); */

});